import { Colors } from "../../../consts/Colors";
import FONTS from "../../../consts/Fonts";
import { downloadFile } from "../../../sydo/utils/DownloadFile";
import ButtonText from "../../global/buttons/ButtonText";
import ButtonUnderlineText from "../../global/buttons/ButtonUnderlineText";

export default class QuestionPanel extends Phaser.GameObjects.Container {
    constructor(scene, x, y, {
        numquestion,
        totQuestion,
        question,
        textIndice
    }) {
        super(scene, x, y, []);
        this.soundManager = scene.soundManager
        this.scene = scene;
        scene.add.existing(this);

        // Ajout fond
        let background = this.scene.add.rectangle(0, 0, 570, this.scene.height, Colors.Elmt.LightGrey).setOrigin(0, 0);
        this.add(background);

        // Ajout num question
        this.numQuestionText = this.scene.add.text(80, 66, `QUESTION ${numquestion}/${totQuestion}`, {
            fontFamily: FONTS.InterRegular,
            fontSize: '14px',
            color: Colors.Text.DarkGrey,
        }
        )
        this.numQuestionText.setOrigin(0)
        this.add(this.numQuestionText)

        // Titre question
        this.titreQuestionText = this.scene.add.text(80, 100, question, {
            fontFamily: FONTS.InterSemiBold,
            fontSize: '28px',
            color: Colors.Text.Black,
            wordWrap: { width: 410 }
        }).setOrigin(0)
        this.add(this.titreQuestionText)

        // Ajout bouton aide
        this.aideButton = new ButtonUnderlineText(this.scene, 80, this.titreQuestionText.y + this.titreQuestionText.height + 16, {
            text: "Besoin d'un indice ?",
            textColor: Colors.Text.Orange,
            textHoverColor: Colors.Text.Blue
        })
        this.add(this.aideButton)
        this.aideButton.x += this.aideButton.width/2
        this.aideButton.y += this.aideButton.height/2
        this.aideButton.setClickFunction( () => {
            this.scene.addPopUpAide(textIndice);
        })

        // Ajout image
        this.image = this.scene.add.image(background.width /2, this.aideButton.y + 22, 'Chapitre4_ordi_question_image').setOrigin(0.5, 0);
        this.add(this.image)

        this.image.setInteractive({useHandCursor: true})
        this.image.on('pointerup', () => {
            downloadFile('assets/images/chapitre4/', 'CVC-Chapitre4-Image.png')
        })

        // Ajout sous titre
        this.sousTitreText = this.scene.add.text(background.width /2, this.image.y + this.image.height + 15, "Pour faciliter vos recherches, nous vous conseillons de télécharger l’image sur votre appareil.", {
            fontFamily: FONTS.Inter18Italic,
            fontSize: '18px',
            color: Colors.Text.DarkGrey,
            align: "center",
            wordWrap: { width: 440 }
        }).setOrigin(0.5, 0)
        this.add(this.sousTitreText)

        // Bouton fermer panneau
        this.retourButton = new ButtonText(this.scene, 32, background.height - 32, {
            text: "⬅ Retourner fouiller la pièce",
            textColor: Colors.Text.Orange,
            textHoverColor: Colors.Text.Blue,
        })
        this.add(this.retourButton)
        this.retourButton.x += this.retourButton.width/2
        this.retourButton.y -= this.retourButton.height/2
        this.retourButton.setClickFunction( () => {
            this.scene.closePopup();
        })

        this.setSize(background.width, background.height);
    }

    animOut(endFunc){
        this.scene.tweens.add({
            targets: this,
            x: -this.width,
            duration: 500,
            ease: 'Cubic.easeInOut',
            onComplete: () => {
                if(endFunc)
                    endFunc()
            }
        });
    }

    animIn(){
        this.soundManager.playOnce('QuestionIn')
        this.x = -this.width
        this.scene.tweens.add({
            targets: this,
            x: 0,
            duration: 500,
        });
    }

    setLocked(){
        this.image.disableInteractive();
        this.aideButton.disableInteractive();
        this.retourButton.disableInteractive();

        this.scene.input.setDefaultCursor('default')
    }

    setUnlocked(){
        this.image.setInteractive({useHandCursor: true});
        this.aideButton.setInteractive({useHandCursor: true});
        this.retourButton.setInteractive({useHandCursor: true});
    }
}